import * as THREE from 'three';
import { CSS3DRenderer } from 'three/examples/jsm/renderers/CSS3DRenderer.js';

export interface Renderers {
  scene: THREE.Scene;
  cssScene: THREE.Scene;
  camera: THREE.PerspectiveCamera;
  webgl: THREE.WebGLRenderer;
  css3d: CSS3DRenderer;
  webglEl: HTMLElement;
  cssEl: HTMLElement;
  resize: () => void;
}

export function createRenderers(viewport: HTMLElement): Renderers {
  const webglEl = viewport.querySelector<HTMLElement>('#webgl-layer')!;
  const cssEl = viewport.querySelector<HTMLElement>('#css3d-layer')!;

  const scene = new THREE.Scene();
  const cssScene = new THREE.Scene();

  const w = viewport.clientWidth;
  const h = viewport.clientHeight;

  const camera = new THREE.PerspectiveCamera(46, w / h, 0.1, 200);
  camera.position.set(0, 4.5, 22);
  camera.lookAt(0, 0.6, 0);

  const webgl = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  webgl.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  webgl.setSize(w, h);
  webgl.setClearColor(0x000000, 0);
  webgl.outputColorSpace = THREE.SRGBColorSpace;
  webglEl.appendChild(webgl.domElement);

  const css3d = new CSS3DRenderer();
  css3d.setSize(w, h);
  css3d.domElement.style.position = 'absolute';
  css3d.domElement.style.inset = '0';
  css3d.domElement.style.pointerEvents = 'none';
  cssEl.appendChild(css3d.domElement);

  // Lights — minimal and considered
  const ambient = new THREE.AmbientLight(0xfff4dc, 0.85);
  scene.add(ambient);
  const key = new THREE.DirectionalLight(0xfff1cf, 0.45);
  key.position.set(4, 8, 6);
  scene.add(key);
  const fill = new THREE.DirectionalLight(0xc9bea4, 0.18);
  fill.position.set(-6, 2, -4);
  scene.add(fill);

  function resize() {
    const W = viewport.clientWidth;
    const H = viewport.clientHeight;
    camera.aspect = W / H;
    camera.updateProjectionMatrix();
    webgl.setSize(W, H);
    css3d.setSize(W, H);
  }

  window.addEventListener('resize', resize);

  return { scene, cssScene, camera, webgl, css3d, webglEl, cssEl, resize };
}
